import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import { viewCollectionsList } from "../../Redux/Actions/collectionsActions";
import { columnsSubCollectionsResale } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";

const ViewCollections = () => {
  const dispatch = useDispatch();

  const { id: fetchedId } = useParams();

  const [foundCollection, setFoundCollection] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(async (page, limit) => {
    const subCollectionData = {
      page,
      limit,
      collection_id: fetchedId,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    try {
      await dispatch(viewCollectionsList(subCollectionData));
    } catch {
      toast.error("Failed to fetch projects");
    }
  },
    [dispatch, debouncedSearch, dateRange, fetchedId]
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);


  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, debouncedSearch, dateRange, fetchDetails]);


  const { collections, subCollections } = useSelector(
    (state) => state.collections || {}
  );

  useEffect(() => {
    if (collections?.total) {
      setPagination((prevData) => ({ ...prevData, total: collections.total }));
    }
  }, [collections]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  useEffect(() => {
    const foundCollection = subCollections?.data
      ? subCollections.data.find(
        (collection) => String(collection._id) === String(fetchedId)
      )
      : [];
    setFoundCollection(foundCollection);
  }, [subCollections, fetchedId]);

  const handleDateRangeApply = (start, end) => {
    setDateRange(start === null && end === null ? { start: null, end: null } : { start, end });
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  return (
    <>
      <TableComponent
        h3heading={foundCollection?.name || "No Data"}
        buttonhead={canAdd ? "Add Sub Collection" : null}
        setState={setSearchQuery}
        navigateTo={canAdd ? `/collections/${fetchedId}/sub/add` : null}
        buttonhead2="Back To Collections"
        navigateTo2="/collections"
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
        columns={columnsSubCollectionsResale(canEdit)}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        dataSource={
          Array.isArray(subCollections?.data) ? subCollections.data : []
        }
      ></TableComponent>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ViewCollections;
